var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modpack" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "touch-swipe",
            rawName: "v-touch-swipe",
            value: { onMove: _vm.onTouchMove, onEnd: _vm.onTouchEnd },
            expression: "{ onMove: onTouchMove, onEnd: onTouchEnd }",
          },
        ],
        staticClass: "modpack--list-wrapper",
      },
      [
        _vm.isBigScreen
          ? _c("base-modpack-controls", {
              attrs: {
                "use-left": !_vm.isFirstPage,
                "use-right": !_vm.isLastPage,
              },
              on: {
                previous: function ($event) {
                  return _vm.jumpToPage(_vm.state.page - 1)
                },
                next: function ($event) {
                  return _vm.jumpToPage(_vm.state.page + 1)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.rows, function (listIndex) {
          return _c(
            "div",
            {
              key: listIndex,
              staticClass: "modpack--list",
              class: {
                "modpack--list-animate": !_vm.state.isSwiping,
              },
              style: _vm.listPositioningStyle,
            },
            _vm._l(
              _vm.value.filter(function (value, index) {
                return index % _vm.rows === listIndex - 1
              }),
              function (mod) {
                return _c("base-modpack-list-item", {
                  key: mod.key,
                  ref: "modpackItem",
                  refInFor: true,
                  staticClass: "modpack--list-item",
                  class: { "modpack--list-item-disabled": _vm.disabled },
                  attrs: { value: mod },
                  on: {
                    "on-mod-selected": function ($event) {
                      return _vm.emit("on-mod-selected", $event)
                    },
                  },
                })
              }
            ),
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }